export default __webpack_public_path__ + "static/trip-com-d1f975928514ada9ee86350c5bf38f14.svg";